import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { danger } from 'redux-store/reducers/common-reducer';

import { API, destroy } from 'utils/api';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../delete-user.i18n.json'));

import type { Dispatch, ThunkAction } from 'types';

const { USERS } = API.END_POINTS;
const MSG_KEY = 'delete_user';

export const deleteUser = (
  userId: number,
  password: string,
  reason: string | null,
  comment: string | undefined
): ThunkAction => (
  async (dispatch: Dispatch) => {
    const url = USERS.deleteUser(userId);

    try {
      dispatch(showLoading(url));

      await destroy(url, {
        data: {
          password,
          reason,
          comment
        }
      }, { suppressGlobalNotification: true });

      dispatch(hideLoading(url));

      return true;
    } catch (error) {
      const details = error?.response?.data?.detail;
      const message = details ?? __t(`${MSG_KEY}.errors.unable_to_delete`);

      logError(error);

      dispatch(hideLoading(url));
      dispatch(danger(message));

      return false;
    }
  }
);
